angular.module 'zc.projects'

.controller 'IncentiveListCtrl', ($scope, $state, $translate, Page, Incentive, currentProject, Devise) ->
  Page.setBodyClass ''
  $translate('projectsIncentives.list.incentiveList').then((translation) ->
    Page.setTitle(translation)
  )

  $scope.currentProject = currentProject
  $scope.isMaster = Devise.isMaster()

  $scope.getAllIncentives = ->
    Incentive.all($scope.currentProject.id).then (incentives) ->
      $scope.incentives = incentives

  $scope.getAllIncentives()



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.incentives/list.controller.coffee